import React from 'react';
import PropTypes from 'prop-types';
import SVG_COMPONENTS from './reactsvgs';
import iconTypes from './iconTypes';
import { createStyledComponent } from '@cloudflare/style-container';

var iconStyles = function iconStyles(_ref) {
  var size = _ref.size;
  return {
    width: size,
    height: size,
    fill: 'currentColor'
  };
};

var Icon = function Icon(_ref2) {
  var type = _ref2.type,
      className = _ref2.className,
      label = _ref2.label;
  var Svg = SVG_COMPONENTS[type];
  return (
    /*#__PURE__*/
    React.createElement(Svg, {
      className: className,
      label: label ? label : ''
    })
  );
};

Icon.defaultProps = {
  color: 'currentColor',
  size: 16
};
Icon.displayName = 'Icon';
export default createStyledComponent(iconStyles, Icon);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/Icon.js
// module id = 972
// module chunks = 0